import React from 'react';

import { useTranslation } from '../i18n';

type ShowMoreProps = {
  list: string[];
  limit?: number;
  delimiter?: string;
};

const ShowMore = ({
  list = [],
  limit = 10,
  delimiter = ', ',
}: ShowMoreProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <span>{list.slice(0, limit).join(delimiter)}</span>
      {list.length > limit && (
        <span>{t('OTHERS', { count: list.length - limit })}</span>
      )}
    </div>
  );
};

ShowMore.displayName = 'ShowMore';

export default ShowMore;
